import { createSlice } from '@reduxjs/toolkit'
import {
  getCategoryAction
} from './category.action'

const initialState: Category.CategoryState = {
  isLoading: false,
  error: null,
  categories: {
    limit: 0,
    page: 0,
    records: [],
    total: 0,
    totalPage: 0,
  },
}

const { actions, reducer } = createSlice({
  name: 'case_study_slice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCategoryAction.pending, (state, action) => {
        state.isLoading = true
      })
      .addCase(getCategoryAction.fulfilled, (state, action) => {
        state.isLoading = false
        state.categories = action.payload
      })
      .addCase(getCategoryAction.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error
      })

    // .addCase(createCategoryAction.pending, (state, action) => {
    //   state.isLoading = true
    // })
    // .addCase(createCategoryAction.fulfilled, (state, action) => {
    //   state.isLoading = false
    // })
    // .addCase(createCategoryAction.rejected, (state, action) => {
    //   state.isLoading = false
    //   state.error = action.error
    // })

    // .addCase(updateCategoryAction.pending, (state, action) => {
    //   state.isLoading = true
    // })
    // .addCase(updateCategoryAction.fulfilled, (state, action) => {
    //   state.isLoading = false
    // })
    // .addCase(updateCategoryAction.rejected, (state, action) => {
    //   state.isLoading = false
    //   state.error = action.error
    // })

    // .addCase(deleteUser.pending, (state, action) => {
    //   state.isLoading = true;
    // })
    // .addCase(deleteUser.fulfilled, (state, action) => {
    //   state.isLoading = false;
    // })
    // .addCase(deleteUser.rejected, (state, action) => {
    //   state.isLoading = false;
    //   state.error = action.error;
    // })
  },
})

export { reducer }
export default actions
